import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _excluded = ["tags"];
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Model, referenceMany } from 'libx';
import { observable, computed } from 'mobx';
import moment from 'moment';
import { camelizeKeys } from '../utils/objectUtil';
import map from 'lodash/map';
import uniq from 'lodash/uniq';
var Skill = (_class = /*#__PURE__*/function (_Model) {
  function Skill() {
    var _this;
    _classCallCheck(this, Skill);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Skill, [].concat(args));
    _initializerDefineProperty(_this, "name", _descriptor, _this);
    _initializerDefineProperty(_this, "description", _descriptor2, _this);
    _initializerDefineProperty(_this, "workspaceId", _descriptor3, _this);
    _initializerDefineProperty(_this, "dateCreated", _descriptor4, _this);
    _initializerDefineProperty(_this, "dateModified", _descriptor5, _this);
    _initializerDefineProperty(_this, "tagIds", _descriptor6, _this);
    return _this;
  }
  _inherits(Skill, _Model);
  return _createClass(Skill, [{
    key: "tags",
    get: function get() {
      var tags = this.rootStore.skillTagStore.tags;
      return referenceMany(tags, this.tagIds, 'id');
    }
  }, {
    key: "parse",
    value: function parse(_ref) {
      var tags = _ref.tags,
        json = _objectWithoutProperties(_ref, _excluded);
      var skillTagStore = this.rootStore.skillTagStore;
      var tagIds = this.tagIds.slice();
      skillTagStore.tags.set(tags);

      // Since tags are managed when saving the skill itself,
      // and since tags are not filtered in any way by perms,
      // replace entirely when an update comes in.
      // Also, tags do not have a reference field and are
      // shared among multiple docs, so therefore we maintain an ID list.
      if (tags) {
        tagIds = map(tags, 'id');
      }
      return _objectSpread(_objectSpread({}, camelizeKeys(json)), {}, {
        tagIds: uniq(tagIds),
        description: json.description || '',
        dateCreated: json.date_created && moment(json.date_created),
        dateModified: json.date_modified && moment(json.date_modified)
      });
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "description", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "workspaceId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "dateCreated", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "dateModified", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "tagIds", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "tags", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "tags"), _class.prototype), _class);
export { Skill as default };
//# sourceMappingURL=Skill.js.map
